export default "__VITE_ASSET__DlxiLNtx__"